import { render, staticRenderFns } from "./bmi-icon.vue?vue&type=template&id=216b7390&scoped=true"
import script from "./bmi-icon.vue?vue&type=script&lang=js"
export * from "./bmi-icon.vue?vue&type=script&lang=js"
import style0 from "./bmi-icon.vue?vue&type=style&index=0&id=216b7390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b7390",
  null
  
)

export default component.exports